import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useCloseTemplates } from "@api/closeTemplate.api";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

/**
 * Multi-select filter for the Schedules page — filters by the schedule's
 * Service (close template). Distinct from `CloseTemplateFilter`
 * (`closeTemplateIds`, used by the Work page) so the two pages' Service
 * selections never share state.
 */
export const ScheduleTemplateFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: templates = [] } = useCloseTemplates({
        includeArchived: true,
    });

    const options = useMemo<FilterMultiselectOption[]>(
        () =>
            templates.map((template) => ({
                value: template.id,
                label: template.name,
                searchableLabel: template.name,
            })),
        [templates],
    );

    const value = filters.scheduleTemplateIds ?? [];

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                maxListHeight={340}
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    onChange({
                        scheduleTemplateIds: selected.length
                            ? selected
                            : undefined,
                    });
                }}
                name="scheduleTemplate"
                onBlur={noop}
            />
        </div>
    );
};
